import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react"
import { Alert, AlertTitle, CircularProgress, Container, List, ListItem, Drawer as MuiDrawer } from '@mui/material';
import { Router, Edit, Settings, Search, Build, Visibility, Sync, InfoOutlined } from '@mui/icons-material'
import { useConfirmationDialog } from "../providers/ConfirmationDialogProvider";
import AmplifierCard from "../components/AmplifierCard"
import makeStyles from "@mui/styles/makeStyles"
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CloseIcon from '@mui/icons-material/Close'
import NumberSlider from "../components/NumberSlider"
import AmplifiersList from "../components/AmplifiersList";
import GuardiaoStatusEnum from '../enums/GuardiaoStatusEnum';
import {
    Grid,
    Button,
    Modal,
    Typography,
    Autocomplete,
    TextField,
    InputAdornment,
    Checkbox,
    Box,
    FormControlLabel,
    IconButton,
    Tooltip,
    Card,
    CardHeader,
    CardContent,
    LinearProgress,
    Fab,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon
} from '@mui/material'
import commandsProvider from "../providers/CommandsProvider";
import amplifiersProvider from '../providers/AmplifiersProvider';
import Helper from "../providers/Helpers"
import { useSnackbar } from "../providers/SnackbarProvider";

export default function Amplifiers(props) {
    const { openSnackbar } = useSnackbar();
    const { openConfirmationDialog } = useConfirmationDialog();

    const [amplifiers, setAmplifiers] = useState([])
    const [amplifierList, setAmplifiersList] = useState([])
    const [amplifierData, setAmplifierData] = useState({
        amplifiers: [],
        groups: []
    });

    const [autocompleteList, setAutocompleteList] = useState([])
    const [groups, setGroups] = useState([])
    const [individualTimer, setIndividualTimer] = useState(500)
    const [broadcastTimer, setBroadcastTimer] = useState(80000)
    const [open, setOpen] = useState(false)
    const [syncTimer, setSyncTimer] = useState(amplifiersProvider.getSyncTimer());
    const [offTimer, setOffTimer] = useState(amplifiersProvider.getOfflineTimer());
    const [searchTimer, setSearchTimer] = useState()
    const [offLineTimer, setOfflineTimer] = useState()
    const [guardiaoStatus, setGuardiaoStatus] = useState(GuardiaoStatusEnum.ONLINE);
    const [modem, setModem] = useState({})
    const [central, setCentral] = useState({})
    const [isLoading, setIsLoading] = useState(true);
    const [hideAmplifier, setHideAmplifier] = useState(true);
    const [syncing, setSyncing] = useState(false);
    const [desktopStatus, setDesktopStatus] = useState("não informado");
    const [currentFilter, setCurrentFilter] = useState('all');

    const [initialLoadComplete, setInitialLoadComplete] = useState(false);

    const [isLoadingAmplifierTimer, setIsLoadingAmplifierTimer] = useState(false);

    const [isLoadingAmplifiersSearch, setIsLoadingAmplifiersSearch] = useState(false);

    const [openSpeedDial, setOpenSpeedDial] = useState(false);

    var [amplifierCounter, setCommandCounter] = useState(1)

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    //Lista de amplificadores
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false)
    //Configuração de amplificadores
    const [configDrawerOpen, setConfigDrawerOpen] = useState(false);

    const amplifiersListRef = useRef(null);

    const handleSpeedDialOpen = (event) => {
        setOpenSpeedDial(!openSpeedDial);
    }

    const handleDrawerToggle = () => {
        if (drawerOpen && hasUnsavedChanges) {
            openConfirmationDialog({
                title: 'Alterações não Salvas',
                message: 'Há alterações não salvas em um ou mais amplificadores. Se fechar o painel agora, essas alterações serão perdidas. Deseja realmente fechar?',
                confirmButtonText: 'Sim, Fechar',
                cancelButtonText: 'Não, Continuar',
                confirmButtonColor: 'info',
                onConfirm: () => {
                    // Reseta edições usando a ref
                    if (amplifiersListRef.current) {
                        amplifiersListRef.current.resetEditing();
                    }
                    setDrawerOpen(false);
                }
            });
            return;
        }
        setDrawerOpen(!drawerOpen);
    };

    const handleConfigDrawerToggle = () => {
        if (isLoadingAmplifiersSearch || isLoadingAmplifierTimer) {
            openConfirmationDialog({
                title: 'Operação em Andamento',
                message: 'Há uma operação em andamento. Deseja realmente fechar o painel de configurações?',
                confirmButtonText: 'Sim, Fechar',
                cancelButtonText: 'Não, Continuar',
                confirmButtonColor: 'info',
                onConfirm: () => setConfigDrawerOpen(false)
            });
            return;
        }

        if (!configDrawerOpen) {
            amplifiersProvider.getAllowNewAmplifiers();
        }
        setConfigDrawerOpen(!configDrawerOpen);
    };

    const getActiveFilterAmplifiers = useCallback(function (list) {
        let triggers = document.querySelectorAll('input[name="filter-display"]');
        let flag = false;

        triggers.forEach(trigger => {
            if (!!trigger.checked) {
                flag = true;
                updateRenderList(trigger.value, list);
            }
        });

        if (!flag) {
            updateRenderList("all", list);
        }
    }, []);

    const updateRenderList = function (status, list) {
        document.querySelector("#filter-amplifier").value = "";
        setCurrentFilter(status); // Atualiza o filtro atual
    };

    const autocomplete = (event) => {
        //vinculado ao filtro
        if (event.target.innerText === undefined || event.target.innerText === "") {
            setAmplifiers(amplifiersProvider.getRegularAmplifiers())
        }
        else {
            let filtered = amplifiers.find((item) => event.target.innerText.includes(item.network.dlAddress));

            if (!!filtered) {
                setAmplifiers(Array(filtered))
            }
        }
    }

    const amplifierCounterList = () => {
        return amplifiersProvider.getRegularAmplifiers().length;
    }

    const amplifiersOnline = () => {
        return amplifiersProvider.getRegularAmplifiers().filter(amp => amp.status === "online").length;
    }

    const amplifiersSearching = () => {
        return amplifiersProvider.getRegularAmplifiers().filter(amp => amp.status === "buscando").length;
    }

    const amplifiersOffline = () => {
        return amplifiersProvider.getRegularAmplifiers().filter(amp => amp.status === "offline").length;
    }

    const amplifiersNoTracked = () => {
        return amplifiersProvider.getRegularAmplifiers()
            .filter(amp => amp.serialNumber && amp.network.dhAddress.includes("a201")).length;
    }

    const amplifierMode = (value) => {
        setIsLoadingAmplifiersSearch(true);

        fetch(`${process.env.REACT_APP_URL}/userfetchdata/change/status?selector=${value}`, {
            method: "GET",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Falha ao alterar o modo do amplificador');
                }
                openSnackbar("Modo de busca de amplificadores alterado com sucesso!", "success");
                resetSerialService();
            })
            .catch(error => {
                console.error('Error:', error);
                openSnackbar("Erro ao alterar o modo de busca amplificador", "error");
            })
            .finally(() => {
                setIsLoadingAmplifiersSearch(false);
            });
    }

    const resetSerialService = () => {
        setTimeout(async () => {
            try {
                if (process.env.REACT_APP_MODE === "desktop") {
                    const response = await fetch(`${process.env.REACT_APP_URL}/account/reset-serial-service`, {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                            "Authorization": "Bearer " + props.token
                        }
                    });

                    if (!response.ok) {
                        throw Error("Erro ao reiniciar a aplicação.");
                    }

                    const data = await response.json();

                    if (data.operationMode === 3 || data.operationMode === 6) {
                        // Se for desenvolvimento
                        if (data.isDevelopment) {
                            openSnackbar(`${data.message}`, "success");
                            return;
                        }

                    }
                }
            } catch (error) {
                console.log("🚀 ~ resetSerialService ~ error:", error);
                openSnackbar(error.message, "error");
            }
        }, 3000);
    }

    const clearAmplifierList = async () => {
        //Função para desenvolvedor
        try {
            if (!!localStorage.getItem("token") && !!sessionStorage.getItem("serial")) {
                const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/delete-all?serialNumber=${sessionStorage.getItem("serial")}`, {
                    method: "GET",
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                });

                if (response.ok) {
                    setModem({})
                    setCentral({})
                    setAmplifiers([])
                    setAmplifiersList([])
                    setAutocompleteList([])

                    Helper.Notification(`Os dados de amplicadores relacionados ao número de série ${sessionStorage.getItem("serial")} foram EXCLUÍDOS.`, "Rede");
                }
                else {
                    throw Error("Não foi possível limpar os dados de amplificadores!");
                }
            }
            else {
                throw Error("Não há credenciais para fazer a requisição!");
            }
        }
        catch (error) {
            console.log("🚀 ~ clearAmplifierList ~ error:", error)
        }
    }

    /*const synchronizeAmplifierList = async (dataList) => {
        setIsLoading(true);

        try {
            if (!!localStorage.getItem("token") && !!sessionStorage.getItem("serial")) {
                //window.alert("BUSCANDO PO");
                const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/get-by-serial`, {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify(sessionStorage.getItem("serial"))
                });

                if (!response.ok) {
                    throw Error("Não foi possível obter dados de Amplificadores!");
                }

                const res = await response.json();

                if (!!res) {
                    traitAmplifiersType(res.amplifiers);
                }
            }
            else {
                throw Error("Sem credenciais para realizar a busca!");
            }
        }
        catch (error) {
            console.log("🚀 ~ getAmplifiersBySerial ~ error:", error)
        }

        try {
            // Substitua o trecho do método synchronizeAmplifierList por este:*/

    const synchronizeAmplifierList = async (dataList) => {
        setIsLoading(true);

        /*try {
            if (!!localStorage.getItem("token") && !!sessionStorage.getItem("serial")) {
                // Busca os amplificadores atuais
                const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/get-by-serial`, {
                    method: "POST",
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify(sessionStorage.getItem("serial"))
                });

                if (!response.ok) {
                    throw Error("Não foi possível obter dados de Amplificadores!");
                }

                const res = await response.json();

                if (!!res) {
                    traitAmplifiersType(res.amplifiers);
                }
            } else {
                throw Error("Sem credenciais para realizar a busca!");
            }
        } catch (error) {
            console.log("🚀 ~ getAmplifiersBySerial ~ error:", error)
        }*/

        try {
            // Mapeia dataList para o formato da classe Amplifier
            const amplifiersToSync = dataList.map(item => ({
                ID: item.id || 0,
                FK_CENTRAL_AMPLIFICADOR: (item.groupId).substring(0, 12),
                DS_NOME: item.name || "",
                DS_MY: item.network?.myAddress || "",
                DS_DH: item.network?.dhAddress || "",
                DS_DL: item.network?.dlAddress || "",
                DS_LOCALIZACAO: item.location || "",
                FK_VL_CADASTR_GRUPO: item.groupId || "",
                DS_STATUS: item.status || "",
                VL_BATERIA: item.batteryLevel || 0,
                VL_FONTE: item.powerLevel || 0,
                VL_SINAL: item.signalLevel || 0,
                DS_NUMSERIE: item.serialNumber || "",
                DT_AMPLIFICADOR: item.amplifierDate ? new Date(item.amplifierDate).toISOString() : new Date().toISOString(),
                STATUS: item.statusLogs || []
            }));

            const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/synchronize-all`, {
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(amplifiersToSync)
            });

            if (!response.ok) {
                throw Error(JSON.stringify({ type: "server", message: `Não foi possível sincronizar a lista de amplificadores` }));
            }

            const res = await response.json();

            if (!!res) {
                Helper.Notification('Sincronização de dados realizada com sucesso! 🤙', 'Sincronização', 500);
            }
        } catch (error) {
            let response = Helper.TryParseJson(error);

            if (response) {
                console.log("🚀 ~ synchronizeAmplifierData ~ error:", response.message)

                if (JSON.parse(error).type === "server") {
                    window.alert(response.message);
                }
            } else {
                console.log("🚀 ~ synchronizeAmplifierData ~ error:", error)
            }
        }

        setIsLoading(false);
    }

    /*if (!response.ok) {
        throw Error(JSON.stringify({ type: "server", message: `Não foi possível sincronizar a lista de amplificadores` }));
    }

    const res = await response.json();

    if (!!res) {
        Helper.Notification('Sincronização de dados realizada com sucesso! 🤙', 'Sincronização', 500);
    }
}
catch (error) {
    let response = Helper.TryParseJson(error);

    if (response) {
        console.log("🚀 ~ synchronizeAmplifierData ~ error:", response.message)

        if (JSON.parse(error).type === "server") {
            window.alert(response.message);
        }
    }
    else {
        console.log("🚀 ~ synchronizeAmplifierData ~ error:", error)
    }
}

setIsLoading(false);
}*/

    const changeBroadcastTimer = () => {
        fetch(`${process.env.REACT_APP_URL}/userfetchdata/change/broadcast?timer=${broadcastTimer}`, {
            method: "GET",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            }
        })
    }

    const changeIndividualTimer = () => {
        fetch(`${process.env.REACT_APP_URL}/userfetchdata/change/individual?timer=${individualTimer}`, {
            method: "GET",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            }
        })
    }

    const handleCheckBoxBridgeMode = async () => {
        try {
            setIsLoadingAmplifiersSearch(true);
            await amplifiersProvider.setBridgeMode(!amplifiersProvider.getBridgeMode());
            openSnackbar("Modo de busca de amplificadores alterado com sucesso!", "success");
            resetSerialService();
        } catch (error) {
            openSnackbar("Erro ao alterar o modo de busca amplificador", "error");
        } finally {
            setIsLoadingAmplifiersSearch(false);
        }
    }

    const handleCheckBoxNewAmplifiers = async () => {
        try {
            setIsLoadingAmplifiersSearch(true);
            await amplifiersProvider.setAllowNewAmplifiers(
                !amplifiersProvider.getAllowNewAmplifiers()
            );
            openSnackbar("Configuração atualizada com sucesso!", "success");
        } catch (error) {
            openSnackbar(error.message || "Erro ao atualizar configuração", "error");
        } finally {
            setIsLoadingAmplifiersSearch(false);
        }
    }

    const changeTimer = async () => {
        try {
            setIsLoadingAmplifierTimer(true);
            await amplifiersProvider.setTimers(syncTimer, offTimer);
            openSnackbar("Tempo de Sincronização alterado com sucesso!", "success");
        } catch (error) {
            openSnackbar(error.message || "Erro ao alterar o tempo de sincronização", "error");
            console.error("Erro ao alterar timers:", error);
        } finally {
            setIsLoadingAmplifierTimer(false);
        }
    }

    const traitAmplifiersType = (amplifiers) => {
        console.log("🚀 ~ traitAmplifiersType ~ amplifiers:", amplifiers);

        setAmplifiersList(amplifiers);

        let listAutocomplete = [];
        let list = [];

        amplifiers.forEach(item => {
            if (item.name !== "Modem" && item.name !== "Central" && item.name !== "undefined") {
                listAutocomplete.push({ label: item.serialNumber })
            }

            if (!!item.name || item.name !== "undefined") {
                switch (item.name) {
                    case "Central":
                        setCentral(item);
                        break;
                    case "Modem":
                        setModem(item);
                        break;
                    default:
                        item.show = true;
                        list.push(item);
                        break;
                }
            }
        });

        setAmplifiersList(list);
        setAutocompleteList(listAutocomplete);

        getActiveFilterAmplifiers(list);
    }

    const getAmplifiersBySerial = useCallback(async () => {
        if (!!searchTimer) {
            setIsLoading(true);
            try {
                if (!!localStorage.getItem("token") && !!sessionStorage.getItem("serial")) {
                    //window.alert("BUSCANDO PO");
                    const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/get-by-serial`, {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("token")
                        },
                        body: JSON.stringify(sessionStorage.getItem("serial"))
                    });

                    if (!response.ok) {
                        throw Error("Não foi possível obter dados de Amplificadores!");
                    }

                    const res = await response.json();

                    if (!!res) {
                        traitAmplifiersType(res.amplifiers);
                    }
                }
                else {
                    throw Error("Sem credenciais para realizar a busca!");
                }
            }
            catch (error) {
                console.log("🚀 ~ getAmplifiersBySerial ~ error:", error)
            }
            finally {
                setIsLoading(false);
                //setTimeout(getAmplifiersBySerial, (searchTimer * 60) * 1000);

                setTimeout(getAmplifiersBySerial, 20000);
            }
        }
        else {
            getAmplifierTimer();
        }
    }, [searchTimer])

    const getGroupsBySerial = async () => {
        try {
            if (!!localStorage.getItem("token") && !!sessionStorage.getItem("serial")) {
                const response = await fetch(`${process.env.REACT_APP_URL}/group/groups`, {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify({
                        "serialNumber": sessionStorage.getItem("serial"),
                    })
                });

                if (!response.ok) {
                    throw Error("Não foi possível obter dados dos grupos");
                }

                const res = await response.json();

                if (!!res) {
                    setGroups(res)
                }
            }
            else {
                throw Error("Não há credenciais para fazer a requisição!");
            }
        }
        catch (error) {
            console.log("🚀 ~ getGroupsBySerial ~ error:", error)
        }
    }

    const getAmplifierTimer = async () => {
        try {
            if (!!localStorage.getItem("token")) {
                const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/timer/converted`, {
                    method: 'GET',
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                });

                if (!response.ok) {
                    throw Error("Não foi possível obter as informações de tempo!");
                }

                const res = await response.json();

                if (!!res) {
                    setSearchTimer(res.searching)
                    setOfflineTimer(res.offline)
                    setSyncTimer(res.searching)
                    setOffTimer(res.offline)
                }
            }
            else {
                throw Error("Não há credenciais para fazer a requisição!");
            }
        }
        catch (error) {
            console.log("🚀 ~ getAmplifierTimer ~ error:", error)
        }
    }

    const controlActionButton = async (action) => {
        try {
            setIsLoading(true);
            switch (action) {
                case "synchronize":
                    const regularAmps = amplifiersProvider.getRegularAmplifiers();
                    const ampsWithModemCentral = [
                        ...(central && central.serialNumber ? [central] : []),
                        ...(modem && modem.serialNumber ? [modem] : []),
                        ...regularAmps
                    ];
                    await synchronizeAmplifierList(ampsWithModemCentral);
                    break;
                case "delete":
                    await clearAmplifierList();
                    break;
                default:
                    break;
            }
        }
        catch (error) {
            console.log("🚀 ~ controlActionButton ~ error:", error)
        }
        finally {
            setIsLoading(false);
        }
    }

    //Ações dos botões flutuantes. Sempre deixar após as declarações.
    const actions = [
        {
            icon: <Edit />,
            name: 'Editar Amplificadores',
            onClick: handleDrawerToggle,
            enable: props.role?.editar !== false,
        },
        {
            icon: <Build />,
            name: 'Configurar Amplificadores',
            onClick: handleConfigDrawerToggle,
            enable: true,
        },
        {
            icon: <Sync />, // Adicione o import do ícone
            name: 'Sincronizar com a Web',
            onClick: () => openConfirmationDialog({
                title: 'Sincronizar com a Web',
                message: 'Será executada a sincronização de dados dos Amplificadores.\n\nOs dados em Nuvem (Web) serão apagados e substituidos pelos dados Locais (Desktop).\n\nIsso pode demorar um pouco.\n\nDeseja prosseguir?',
                confirmButtonColor: 'info',
                onConfirm: () => controlActionButton("synchronize")
            }),
            enable: JSON.parse(localStorage.getItem("user")).dS_NOME.includes("suporte03deltafire") || process.env.REACT_APP_ENVIROMENT === "development",
        }
    ];

    // Principal useEffect para gerenciar estado
    // Handler para atualização do estado dos amplificadores
    const updateAmplifiersState = useCallback((state) => {

        setSyncTimer(state.syncTimer);
        setOffTimer(state.offlineTimer);

        setCentral(state.central || {});
        setModem(state.modem || {});

        let filteredAmps = [...state.amplifiers];

        // Aplica filtros
        switch (currentFilter) {
            case 'online':
                filteredAmps = filteredAmps.filter(amp => amp?.status === 'online');
                break;
            case 'buscando':
                filteredAmps = filteredAmps.filter(amp => amp?.status === 'buscando');
                break;
            case 'offline':
                filteredAmps = filteredAmps.filter(amp => amp?.status === 'offline');
                break;
            case 'notracked':
                filteredAmps = filteredAmps.filter(amp => amp?.network.dhAddress && amp.network.dhAddress.includes('a201'));
                break;
            case 'all':
                filteredAmps = state.amplifiers;
                break;
            default:
                filteredAmps = state.amplifiers;
                break;
        }

        setAmplifiers(filteredAmps);
        setAutocompleteList(filteredAmps.map(amp => ({
            serialNumber: amp.serialNumber || '',
            name: amp.name || ''
        })));
        setAmplifierData({
            amplifiers: state.amplifiers,
            groups: groups, // mantém os grupos atuais
        });
        setHasUnsavedChanges(state.hasPendingChanges);
        setIsLoading(state.isProcessing);
    }, [currentFilter, groups]);

    // Principal useEffect para providers
    useEffect(() => {
        // Subscribe no AmplifiersProvider
        const unsubscribe = amplifiersProvider.subscribe((state) => {
            updateAmplifiersState(state);
            if (!initialLoadComplete && state.initialized) {
                setInitialLoadComplete(true);
            }
        });

        // Carrega estado inicial se disponível
        const currentState = amplifiersProvider.getState();
        if (currentState.amplifiers.length > 0) {
            updateAmplifiersState(currentState);
            setInitialLoadComplete(true);
        }

        return () => unsubscribe();
    }, [updateAmplifiersState]);

    // useEffect separado para o CommandsProvider
    useEffect(() => {
        const unsubscribe = commandsProvider.subscribe((state) => {
            setGuardiaoStatus(state.guardiaoStatus);
        });

        return () => commandsProvider.unsubscribe(unsubscribe);
    }, []);

    useEffect(() => {
        if (!!sessionStorage.getItem("serial"))
            amplifiersProvider.loadAmplifiers(sessionStorage.getItem("serial"));

        const interval = setInterval(() => {
            if (!!sessionStorage.getItem("serial"))
                amplifiersProvider.loadAmplifiers(sessionStorage.getItem("serial"));
            console.log("Update amplifiers...")
        }, (searchTimer || 1) * 60 * 1000);

        return () => clearInterval(interval);
    }, [searchTimer]);

    // Controle de visibilidade em um useEffect separado
    useEffect(() => {
        if (process.env.REACT_APP_MODE === 'desktop') {
            setHideAmplifier(!props.modemStatus.status || props.serialPortError);
        } else {
            setHideAmplifier(!GuardiaoStatusEnum.canShowAmplifiers(guardiaoStatus));
        }
    }, [props.modemStatus, props.serialPortError, guardiaoStatus]);

    useEffect(() => {
        amplifiersProvider.getAllowNewAmplifiers();
        getGroupsBySerial();
        setAmplifiers(amplifiersProvider.getRegularAmplifiers());
    }, []);

    // Timer de sincronização
    useEffect(() => {
        setSyncing(!!props.timer);
    }, [props.timer]);

    return (
        <main className="container" style={{opacity: 1, backgroundColor: 'transparent', paddingTop: '1.5rem', paddingBottom: '2rem'}}>
            {(isLoading || isLoadingAmplifierTimer || isLoadingAmplifiersSearch) &&
                <LinearProgress
                    color="secondary"
                    sx={{
                        position: "fixed",
                        top: "0",
                        left: "0",
                        width: "100%",
                        zIndex: "1201"
                    }}
                />
            }

            <div className={hideAmplifier ? "hidden" : ""}>

                <Box sx={{ marginBottom: '1rem' }}>

                    <Box sx={{ 
                        bgcolor: 'transparent',
                        borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                        borderRadius: '0',
                        padding: '8px 0',
                        marginBottom: '1rem',
                        boxShadow: 'none',
                        textAlign: 'center',
                        cursor: 'default',
                        pointerEvents: 'none',
                        userSelect: 'none'
                    }}>
                        <Typography 
                            variant="h5" 
                            component="h3" 
                            sx={{ 
                                fontWeight: 400,
                                color: 'text.secondary',
                                letterSpacing: '0.5px',
                                textTransform: 'uppercase',
                                fontSize: '0.95rem'
                            }}
                        >
                            Dispositivos do Sistema
                        </Typography>
                    </Box>

                    <Grid container spacing={3} justifyContent='space-around' sx={{ mt: 2 }}>
                        <Grid key={0} item xs={12} md={12} lg={6}>
                            <AmplifierCard
                                type="central"
                                role={props.role}
                                groupList={groups}
                                groupName={central.dS_LOCALIZACAO}
                                amplifier={central}
                                amplifierList={amplifiers}
                                setAmplifiersList={setAmplifiersList}
                                setCentral={setCentral}
                                length={amplifiers.length}
                                counter={amplifierCounter++}
                            />
                        </Grid>

                        <Grid key={1} item xs={12} md={12} lg={6}>
                            <AmplifierCard
                                type="modem"
                                role={props.role}
                                groupList={groups}
                                groupName={modem.dS_LOCALIZACAO}
                                amplifier={modem}
                                amplifierList={amplifierList}
                                setAmplifiersList={setAmplifiersList}
                                setModem={setModem}
                                length={amplifiers.length}
                                counter={amplifierCounter++}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ marginBottom: '2rem' }}>
                    <Box sx={{ 
                        bgcolor: 'transparent',
                        borderBottom: '1px solid rgba(224, 224, 224, 0.15)',
                        borderRadius: '0',
                        padding: '6px 0',
                        marginBottom: '1rem',
                        boxShadow: 'none',
                        textAlign: 'center',
                        cursor: 'default',
                        pointerEvents: 'none',
                        userSelect: 'none'
                    }}>
                        <Typography 
                            variant="body2" 
                            component="h4" 
                            sx={{ 
                                fontWeight: 400,
                                color: 'rgba(255, 255, 255, 0.5)',
                                letterSpacing: '0.8px',
                                textTransform: 'uppercase',
                                fontSize: '0.85rem'
                            }}
                        >
                            Filtro
                        </Typography>
                    </Box>
                    <form id="amplifiers-filter" className="amplifier-top__body filter-control">
                        {/* {process.env.REACT_APP_MODE === 'desktop' &&
                        <Tooltip title="Clique aqui para Editar os Temporizadores">
                            <Grid key={2} item xs={informationGrid} md={informationGrid} lg={informationGrid - 2}>
                                <IconButton color="#FFCC00" onClick={handleOpen}><AccessTimeIcon /></IconButton>
                            </Grid>
                        </Tooltip>
                    } */}

                        <input type="radio" id="filter-all-amplifiers" className="filter-control__trigger" name="filter-display" value="all" />
                        <label className="kpi kpi--filter" htmlFor="filter-all-amplifiers" onClick={() => { updateRenderList("all", amplifierList) }}>
                            <div className="kpi__header">
                                <span className="kpi__header__title">Amplificadores Encontrados</span>
                            </div>
                            <div className="kpi__body">
                                <Router className="kpi__body__icon" style={{ fill: "#FFF" }} />
                                <span className="kpi__body__value">{amplifierCounterList()}</span>
                            </div>
                        </label>

                        <input type="radio" id="filter-online-amplifiers" className="filter-control__trigger" name="filter-display" value="online" />
                        <label className="kpi kpi--filter" htmlFor="filter-online-amplifiers" onClick={() => { updateRenderList("online", amplifierList) }}>
                            <div className="kpi__header">
                                <span className="kpi__header__title">Online/Sincronizado</span>
                            </div>
                            <div className="kpi__body">
                                <Router className="kpi__body__icon" style={{ fill: "#34C759" }} />
                                <span className="kpi__body__value">{amplifiersOnline()}</span>
                            </div>
                        </label>

                        <input type="radio" id="filter-searching-amplifiers" className="filter-control__trigger" name="filter-display" value="buscando" />
                        <label className="kpi kpi--filter" htmlFor="filter-searching-amplifiers" onClick={() => { updateRenderList("buscando", amplifierList) }}>
                            <div className="kpi__header">
                                <span className="kpi__header__title">Online/Sincronizando</span>
                            </div>
                            <div className="kpi__body">
                                <Router className="kpi__body__icon" style={{ fill: "#5ACBFA" }} />
                                <span className="kpi__body__value">{amplifiersSearching()}</span>
                            </div>
                        </label>

                        <input type="radio" id="filter-offline-amplifiers" className="filter-control__trigger" name="filter-display" value="offline" />
                        <label className="kpi kpi--filter" htmlFor="filter-offline-amplifiers" onClick={() => { updateRenderList("offline", amplifierList) }}>
                            <div className="kpi__header">
                                <span className="kpi__header__title">Offline</span>
                            </div>
                            <div className="kpi__body">
                                <Router className="kpi__body__icon" style={{ fill: "#FF3B30" }} />
                                <span className="kpi__body__value">{amplifiersOffline()}</span>
                            </div>
                        </label>

                        <input type="radio" id="filter-notracked-amplifiers" className="filter-control__trigger" name="filter-display" value="notracked" />
                        <label className="kpi kpi--filter" htmlFor="filter-notracked-amplifiers" onClick={() => { updateRenderList("notracked", amplifierList) }}>
                            <div className="kpi__header">
                                <span className="kpi__header__title">Não Mapeados</span>
                            </div>
                            <div className="kpi__body">
                                <Router className="kpi__body__icon" style={{ fill: "#FFCC00" }} />
                                <span className="kpi__body__value">{amplifiersNoTracked()}</span>
                            </div>
                        </label>
                    </form>
                </Box>

                <Grid
                    className={process.env.REACT_APP_MODE === "desktop" ? "" : "mb-5"} 
                    key={0} 
                    item 
                    xs={12} 
                    md={12} 
                    lg={12} 
                    sx={{ 
                        display: "block", 
                        width: "100%",
                        marginTop: "1.5rem",
                        marginBottom: "2rem",
                        paddingRight: "0 !important"
                    }}
                >
                    <Autocomplete
                        disablePortal
                        id="filter-amplifier"
                        options={autocompleteList}
                        getOptionLabel={(option) => `${option.serialNumber} - ${option.name ? option.name : 'Sem Nome Registrado'}` || `${option.serialNumber}`}
                        onChange={(event) => autocomplete(event)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '20px',
                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                border: '3px solid #E0E0E0',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                                    borderColor: '#5ACBFA'
                                },
                                '&.Mui-focused': {
                                    borderColor: '#5ACBFA',
                                    boxShadow: '0 6px 16px rgba(90, 203, 250, 0.3)'
                                },
                                '& fieldset': {
                                    border: 'none'
                                }
                            }
                        }}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                placeholder="Pesquisar"
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (<InputAdornment position="start"><Search color="secondary" /></InputAdornment>)
                                }}
                            />
                        }
                    />
                </Grid>
                <Box sx={{ marginTop: '2rem', marginBottom: '2rem' }}>
                    {!!amplifiersProvider.getBridgeMode() && (
                        <Alert
                            severity="info"
                            variant="outlined"
                            sx={{
                                mb: 2,
                                bgcolor: 'rgba(255, 255, 255, 0.05)',
                                border: '3px solid',
                                borderRadius: '20px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                            }}
                        >
                            <AlertTitle>Modo de Operação Bridge Ativo</AlertTitle>
                            O sistema apresentará os amplificadores atrelados através da Bridge.
                        </Alert>
                    )}
                    {!amplifiersProvider.getAllowNewAmplifiers() && (
                        <Alert
                            severity="warning"
                            variant="outlined"
                            sx={{
                                bgcolor: 'rgba(255, 255, 255, 0.05)',
                                border: '3px solid',
                                borderRadius: '20px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                            }}
                        >
                            <AlertTitle>Entrada de Amplificadores Desabilitada</AlertTitle>
                            O sistema não receberá novos amplificadores enquanto esta opção estiver desabilitada
                        </Alert>
                    )}
                </Box>

                <div className="grid grid--center mt-5" data-grid-4x-columns="4" data-grid-3x-columns="4" data-grid-2x-columns="4" data-grid-xl-columns="4" data-grid-lg-columns="3" data-grid-md-columns="3" data-grid-sm-columns="1" data-grid-xs-columns="1">
                    {amplifiers.length > 0
                        ?
                        amplifiers.map(amplifier => (
                            amplifier.serialNumber != null
                                ?
                                (
                                    <div key={amplifier.serialNumber} className="grid__item grid__item--no-grow">
                                        <AmplifierCard
                                            type="amplificador"
                                            role={props.role}
                                            groupList={groups}
                                            groupName={amplifier.location}
                                            amplifier={amplifier}
                                            amplifierList={amplifierList}
                                            setAmplifiersList={setAmplifiersList}
                                            length={amplifiers.length}
                                            counter={amplifierCounter++}
                                        />
                                    </div>
                                )
                                : null
                        ))
                        :
                        <>
                            <center className="grid__item grid__item--full">
                                {isLoading && amplifiersProvider.getAllowNewAmplifiers() ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                                        <CircularProgress color="secondary" size={40} />
                                        <Typography variant="h6" color="textSecondary">
                                            Buscando amplificadores...
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                        <Typography variant="h6" color="textSecondary">
                                            Nenhum amplificador encontrado!
                                        </Typography>
                                    </Box>
                                )}
                            </center>
                        </>
                    }
                </div>
            </div>

            {process.env.REACT_APP_MODE === 'desktop' && hideAmplifier && !isLoading && (
                <div className="info-box info-box--curved info-box--full mt-5" data-status={syncing ? 'buscando' : 'LIGA'}>
                    <div className="info-box__header">
                        {syncing
                            ?
                            <h4 className="info-box__title my-5">SINCRONIZANDO MODEM</h4>
                            :
                            <h4 className="info-box__title my-5">MODEM NÃO ENCONTRADO</h4>
                        }
                    </div>
                    <div className="info-box__body my-5">
                        {syncing ?
                            <i className={`fa fa-usb fa-4x fa-rotate-270 color-info`} aria-hidden="true" ></i>
                            :
                            <i className={`df df-xl df-modem-off color-danger`} aria-hidden="true" ></i>
                        }
                    </div>
                    <div className="info-box__footer my-5">
                        {syncing
                            ?
                            <span>
                                Sincronizando o modem USB. Por favor, aguarde enquanto a conexão é estabelecida.<br />
                                Após a sincronização, a tela de amplificadores ficará disponível.
                            </span>
                            :
                            <span>
                                Não foi possível estabelecer conexão com o modem USB.<br />
                                Verifique o modem e, caso necessário, reinicie o Guardião 2.0.
                            </span>
                        }

                    </div>
                </div>
            )}

            {process.env.REACT_APP_MODE === 'web' && (
                <>
                    {guardiaoStatus === GuardiaoStatusEnum.OFFLINE && (
                        <div className="info-box info-box--curved info-box--full mt-5" data-status="offline">
                            <div className="info-box__header">
                                <h4 className="info-box__title my-5">GUARDIÃO OFFLINE</h4>
                            </div>
                            <div className="info-box__body my-5">
                                <i className="fa fa-laptop fa-4x color-danger" aria-hidden="true"></i>
                            </div>
                            <div className="info-box__footer my-5">
                                <span>
                                    O Guardião Desktop está offline.<br />
                                    Verifique se a aplicação está em execução.
                                </span>
                            </div>
                        </div>
                    )}

                    {guardiaoStatus === GuardiaoStatusEnum.ONLINE_SEM_MODEM && (
                        <div className="info-box info-box--curved info-box--full mt-5" data-status="warning">
                            <div className="info-box__header">
                                <h4 className="info-box__title my-5">GUARDIÃO SEM MODEM</h4>
                            </div>
                            <div className="info-box__body my-5">
                                <i className="fa fa-usb fa-4x fa-rotate-270 color-warning" aria-hidden="true"></i>
                            </div>
                            <div className="info-box__footer my-5">
                                <span>
                                    O Guardião está online mas sem comunicação com o modem.<br />
                                    Verifique a conexão USB do equipamento.
                                </span>
                            </div>
                        </div>
                    )}

                    {/* {guardiaoStatus === GuardiaoStatusEnum.ONLINE_SEM_MODEM && (
                        <div class="info-box info-box--curved info-box--full mt-5" data-status="offline">
                            <div class="info-box__header">
                                <h4 class="info-box__title my-5">MODEM OFFLINE</h4>
                            </div>
                            <div class="info-box__body my-5">
                                <i className="df df-xl df-modem-off color-danger" aria-hidden="true"></i>
                            </div>
                            <div class="info-box__footer my-5">
                                <span>
                                    O modem está offline.<br />
                                    Verifique a conexão local do equipamento.
                                </span>
                            </div>
                        </div>
                    )} */}
                </>
            )}

            {process.env.REACT_APP_MODE === 'desktop' && !hideAmplifier &&
                <Tooltip title="Menu de ações">
                    <SpeedDial
                        open={openSpeedDial}
                        direction="up"
                        onClose={() => setOpenSpeedDial(false)}
                        onOpen={() => setOpenSpeedDial(true)}
                        openOnHover={false}
                        ariaLabel="Menu de ações"
                        sx={{
                            position: 'fixed',
                            bottom: 16,
                            right: 16,
                            '& .MuiFab-secondary': {
                                color: '#FFF',
                                backgroundColor: 'secondary.main',
                                '&:hover': {
                                    backgroundColor: 'secondary.dark',
                                },
                            },
                        }}
                        icon={<Settings />}
                        FabProps={{
                            color: "secondary",
                            sx: { '&:hover': { backgroundColor: 'secondary.dark' } }
                        }}
                        tooltipTitle="Gerencie Amplificadores"
                    >
                        {/* TODO: Ver a possibilidade de remover o array de actions para ter um controle mais facilitado */}
                        {actions
                            .filter(action => action.enable)
                            .map((action) => (
                                <SpeedDialAction
                                    key={action.name}
                                    icon={action.icon}
                                    tooltipTitle={action.name}
                                    onClick={action.onClick}
                                    sx={{
                                        bgcolor: 'secondary.main',
                                        '&:hover': {
                                            bgcolor: 'secondary.dark'
                                        }
                                    }}
                                />
                            ))}
                    </SpeedDial>
                </Tooltip>
            }
            
            { process.env.REACT_APP_MODE === 'desktop' &&
                //TODO: PELO AMOR DE DEUS, FAÇA UMA PARTIAL VIEW PARA ISSO            
                <MuiDrawer
                    anchor="bottom"
                    className={"drawer--priority-4"}
                    open={drawerOpen}
                    onClose={handleDrawerToggle}
                    sx={{
                        '& .MuiDrawer-paper': {
                            height: '100%',
                            maxHeight: 'calc(100vh - 65px)',
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                            bgcolor: '#0D0D0D',
                            padding: 2,
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6">Editor dos Dispositivos do Sistema</Typography>
                        <Button
                            variant="contained"
                            onClick={handleDrawerToggle}
                            color="error"
                            size="small"
                            sx={{ minWidth: '26px', borderRadius: '50%', padding: 0 }}
                        >
                            <CloseIcon />
                        </Button>
                    </Box>

                    <AmplifiersList
                        ref={amplifiersListRef}
                        amplifiers={amplifierData.amplifiers}
                        groups={amplifierData.groups}
                        onEditingStateChange={setHasUnsavedChanges}
                        isDrawerOpen={drawerOpen}
                    />
                </MuiDrawer>
            }

            { process.env.REACT_APP_MODE === 'desktop' &&
                //TODO: PELO AMOR DE DEUS, FAÇA UMA PARTIAL VIEW PARA ISSO
                /*
                * INSTRUÇÕES:
                * 1. Crie um componente separado para o Drawer utilizando o MuiDrawer.
                * 2. O conteúdo do MuiDrawer pode ser variado, deixe um local para o conteúdo dinâmico (slot)
                * 3. O conteúdo deverá notificar se o Drawer poderá ser fechado ou não.
                */
                <MuiDrawer
                    anchor="bottom"
                    className={"drawer--priority-4"}
                    open={configDrawerOpen}
                    onClose={handleConfigDrawerToggle}
                    sx={{
                        '& .MuiDrawer-paper': {
                            height: '100%',
                            maxHeight: 'calc(100vh - 65px)',
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                            bgcolor: '#0D0D0D',
                            padding: 2,
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6">Configurar Amplificadores</Typography>
                        <Button
                            variant="contained"
                            onClick={handleConfigDrawerToggle}
                            color="error"
                            size="small"
                            sx={{ minWidth: '26px', borderRadius: '50%', padding: 0 }}
                        >
                            <CloseIcon />
                        </Button>
                    </Box>

                    <Box sx={{
                        overflow: 'auto',
                        height: "100%",
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'stretch',
                    }}>
                        {/* Card de Temporizadores */}
                        <Card sx={{ position: 'relative', mb: 2 }}>
                            <CardHeader
                                title="Temporizadores do Sistema"
                                titleTypographyProps={{ variant: 'h6' }}
                            >
                            </CardHeader>
                            <CardContent>
                                {isLoadingAmplifierTimer && (
                                    <LinearProgress
                                        color="secondary"
                                        sx={{
                                            width: '100%',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            borderTopLeftRadius: 1,
                                            borderTopRightRadius: 1
                                        }}
                                    />
                                )}
                                <Typography variant="body2" color="text.secondary" mb={2}>
                                    Selecione um valor para os parâmetros a seguir. O Tempo escolhido simboliza um valor em MINUTOS.
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Typography variant="subtitle1" sx={{ width: 100 }}>Sinc.:</Typography>
                                        <NumberSlider time={syncTimer} setValue={setSyncTimer} />
                                    </Box>
                                    {(props.user.name === 'suporte03deltafire' || process.env.REACT_APP_ENVIROMENT === "development") && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Typography variant="subtitle1" sx={{ width: 100 }}>Offline:</Typography>
                                            <NumberSlider time={offTimer} setValue={setOffTimer} />
                                        </Box>
                                    )}
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={changeTimer}
                                        startIcon={<AccessTimeIcon />}
                                        disabled={isLoadingAmplifierTimer}
                                        sx={{ color: '#FFF' }}
                                    >
                                        Salvar Temporizadores
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                        <Card sx={{ position: 'relative' }}>
                            <CardHeader
                                title="Configurações de Busca"
                                titleTypographyProps={{ variant: 'h6' }}
                            >
                            </CardHeader>
                            <CardContent>
                                {isLoadingAmplifiersSearch && (
                                    <LinearProgress
                                        color="secondary"
                                        sx={{
                                            width: '100%',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            borderTopLeftRadius: 1,
                                            borderTopRightRadius: 1
                                        }}
                                    />
                                )}
                                {/* TODO: PELO AMOR DE DEUS, FAÇA UM COMPONENTE PARA ISSO */}
                                <List sx={{ width: '100%' }}>
                                    <ListItem
                                        elevation={2}
                                        sx={{
                                            bgcolor: '#212121',
                                            borderRadius: 1,
                                            mb: 1,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            overflow: 'hidden',
                                            py: 1.5,
                                            px: 2,
                                            border: '2px solid',
                                            borderColor: (theme) => theme.palette.primary.main,
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                boxShadow: 3,
                                                borderColor: (theme) => theme.palette.info.main,
                                            }
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={amplifiersProvider.getBridgeMode()}
                                                    onChange={handleCheckBoxBridgeMode}
                                                    color="secondary"
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                            }
                                            label="Habilitar a Busca por Amplificador Bridge"
                                            sx={{ color: 'white', display: 'block' }}
                                            disabled={isLoadingAmplifiersSearch}
                                        />
                                    </ListItem>
                                    <ListItem
                                        elevation={2}
                                        sx={{
                                            bgcolor: '#212121',
                                            borderRadius: 1,
                                            mb: 1,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            overflow: 'hidden',
                                            py: 1.5,
                                            px: 2,
                                            border: '2px solid',
                                            borderColor: (theme) => theme.palette.primary.main,
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                boxShadow: 3,
                                                borderColor: (theme) => theme.palette.info.main,
                                            }
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={amplifiersProvider.getAllowNewAmplifiers()}
                                                    onChange={handleCheckBoxNewAmplifiers}
                                                    color="secondary"
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                            }
                                            label="Habilitar Entrada de Novos Amplificadores"
                                            sx={{ color: 'white', display: 'block' }}
                                            disabled={isLoadingAmplifiersSearch}
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>

                    </Box>

                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                            <Typography variant="body2" color="text.secondary">
                                Central: {sessionStorage.getItem("serial")}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            {process.env.REACT_APP_MODE === 'desktop' ? (
                                <Typography textAlign="end" variant="body2">v{process.env.REACT_APP_BUILD_VERSION}</Typography>
                            ) : null}
                        </Grid>
                    </Grid>
                </MuiDrawer>
            }
        </main>
    )
}